import * as React from 'react';
export default function PlaceholderPreviewPane(props) {
    return React.createElement("div", { style: props.style });
}
//# sourceMappingURL=PlaceholderPreviewPane.js.map